const state = {
  users: [],
  participants: [],
  roles: [],
  eventRoles: [],
};

export default state;
